/* global VXConfig */
import React     from 'react';
import PropTypes from 'prop-types';

class Header extends React.Component {
	render() {
		let sub            = null;
		let icon           = null;
		let promotionBadge = null;

		if (this.props.hasCount) {
			sub = (
				<span className="h-color-fg-hint text-subinfo">
					{this.props.useSeparator ? '/ ' : ''}{this.props.count} {this.props.countLabel}
				</span>
			);
		}

		if (this.props.hasSubtitle) {
			sub = (
				<span
					className="h-color-fg-hint text-subinfo"
					dangerouslySetInnerHTML={{__html: (this.props.useSeparator ? '/ ' : '') + this.props.subTitle}}
				/>
			);
		}

		if (this.props.icon !== false) {
			icon = <i className={'icon ' + this.props.icon} />;
		}

		if (this.props.promotionBadgeUrl) {
			promotionBadge =
				<img className={"promotion-badge" + (VXConfig.isVXMobilePlatform ? ' right-10' : '')} src={this.props.promotionBadgeUrl} />;
		}

		return React.createElement(
			this.props.headlineType,
			{className: "actor-search__title"},
			icon,
			<span dangerouslySetInnerHTML={{__html: this.props.title}} />,
			sub,
			this.props.appendTitle,
			promotionBadge
		);
	}
}

Header.propTypes = {
	title:             PropTypes.string.isRequired,
	hasCount:          PropTypes.bool,
	count:             PropTypes.number,
	countLabel:        PropTypes.string,
	hasSubtitle:       PropTypes.bool,
	useSeparator:      PropTypes.bool,
	subTitle:          PropTypes.string,
	icon:              PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	appendTitle:       PropTypes.node,
	promotionBadgeUrl: PropTypes.string,
	headlineType:      PropTypes.string,
};

Header.defaultProps = {
	hasCount:          false,
	hasSubtitle:       false,
	subTitle:          '',
	icon:              false,
	useSeparator:      true,
	promotionBadgeUrl: null,
	headlineType:      'h2',
};

export default Header;
